export enum AiSmartReplyContactPlanItemStatus {
    Unscheduled = 0,
    Scheduled = 1,
    Sending = 2,
    Completed = 3,
    Failed = 4,
}
